<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Sifranti_Piloti_vnos-sl.json';
import en from '@/Prevodi/Sifranti_Piloti_vnos-en.json';
import it from '@/Prevodi/Sifranti_Piloti_vnos-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  data() {
    return {
      ime: '',
      priimek: '',
      email: '',
      naslov: '',
      posta: '',
      kraj: '',
      telefon: '',
      klub: '',
      nalet_jadralno: 0,
      nalet_motorno: 0,
      // start_jadralno: '',
      // start_motorno: '',
      // kilometri_jadralno: 0,
      opomba: '',
      instruktor: false,
      instruktorJ: false,
      instruktorUL: false,
      vlecniR: false,
      licenca: '',
      dKlub: false,
      klubi: [],
      jadralniPilot: false,
      motorniPilot: false,
      ultraPilot: false,
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
  },
  mounted() {
    this.Read();
  },
  methods: {
    Read() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Add() {
      if (this.ime !== '' && this.priimek !== '' && this.email !== '' && this.naslov !== '' && this.kraj !== '' && this.posta !== '' && this.telefon !== '' && this.klub !== '' && this.nalet_jadralno !== '' && this.nalet_motorno !== '') {
        let podatki = new URLSearchParams();
        podatki.append('ime', this.ime);
        podatki.append('priimek', this.priimek);
        podatki.append('naslov', this.naslov);
        podatki.append('kraj', this.kraj);
        podatki.append('posta', this.posta);
        podatki.append('telefon', this.telefon);
        podatki.append('klub', this.klub);
        podatki.append('nalet_jadralno', this.nalet_jadralno);
        podatki.append('nalet_motorno', this.nalet_motorno);
        podatki.append('jadralni_pilot', this.jadralniPilot);
        podatki.append('motorni_pilot', this.motorniPilot);
        podatki.append('ultralight_pilot', this.ultraPilot);
        podatki.append('email', this.email);
        // podatki.append('start_jadralno', this.start_jadralno);
        // podatki.append('start_motorno', this.start_motorno);
        // podatki.append('kilometri_jadralno', this.kilometri_jadralno);
        podatki.append('opomba', this.opomba);
        podatki.append('instruktor', this.instruktor);
        podatki.append('instruktor_jadralno', this.instruktorJ);
        podatki.append('instruktor_ultralight', this.instruktorUL);
        podatki.append('vlecni_rating', this.vlecniR);
        podatki.append('licenca', this.licenca);
        axios
            .post("./api/sifranti/piloti/vnos/", podatki, {withCredentials: true})
            .then((response) => {
              // alert("Zapis uspešno dodan!");
              this.text = 'Zapis uspešno dodan!';
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.ime = '';
              this.priimek = '';
              this.naslov = '';
              this.posta = '';
              this.kraj = '';
              this.telefon = '';
              this.klub = '';
              this.nalet_jadralno = '';
              this.nalet_motorno = '';
              // this.start_jadralno = '';
              // this.start_motorno = '';
              // this.kilometri_jadralno = 0;
              this.opomba = '';
              this.instruktor = false;
              this.instruktorJ = false;
              this.instruktorUL = false;
              this.vlecniR = false;
              this.jadralniPilot = false;
              this.motorniPilot = false;
              this.ultraPilot = false;
              this.licenca = '';
              this.$emit('osvezi');
              var requiredPolja = ['ime', 'priimek', 'email', 'naslov', 'kraj', 'posta', 'telefon', 'klub', 'nalet_jadralno', 'nalet_motorno'];
              this.ResetRequired(requiredPolja);
            })
            .catch((napaka) => {
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = 'Napaka pri vnosu podatkov. ' + napaka.response.data.napaka;
              } else {
                this.text = 'Napaka pri vnosu podatkov.';
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            })
      } else {
        var requiredPolja = ['ime', 'priimek', 'email', 'naslov', 'kraj', 'posta', 'telefon', 'klub', 'nalet_jadralno', 'nalet_motorno'];
        this.CheckInputs(requiredPolja);
        // alert("Napaka pri vnosu, preveri ali imaš vse pomembne podatke izpolnjene!");
        this.text = "Napaka pri vnosu, preveri ali imaš vse pomembne podatke izpolnjene!";
        this.types = "Napaka";
        this.ShowNoti = true;
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]);
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    selectKlub(id) {
      let klub = this.klubi.find(vl => vl.id === id);
      if (klub) {
        this.dKlub = false;
        this.klub = klub.naziv;
      }
    },
    OpenKlub() {
      this.dKlub = !this.dKlub;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <!-- 		<div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
              <button class="p-2 btn-back" @click.prevent="$emit('prikaz')"><i class="fas fa-arrow-left fa-2x"></i></button>
              <h4 class="d-flex justify-content-center text-white">Šifrant pilotov</h4>
          </div> -->
  <div class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: ime.length > 0 }" class="label" for="ime">{{$t('labels.ime')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="ime" v-model="ime" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: priimek.length > 0 }" class="label" for="priimek">{{$t('labels.priimek')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="priimek" v-model="priimek" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: naslov.length > 0 }" class="label" for="naslov">{{$t('labels.naslov')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naslov" v-model="naslov" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: posta.length > 0 }" class="label" for="posta">Poštna št.</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="posta" v-model="posta" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: kraj.length > 0 }" class="label" for="posta">{{$t('labels.kraj')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="kraj" v-model="kraj" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: email.length > 0 }" class="label" for="email">{{$t('labels.email')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="email" id="email" v-model="email" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: telefon.length > 0 }" class="label" for="telefon">{{$t('labels.telefon')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="telefon" v-model="telefon" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="namen">{{$t('labels.klub')}} <button v-if="klub !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klub = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlub()">
          <i v-show="!dKlub" class="fas fa-chevron-right"></i>
          <i v-show="dKlub" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="klub" @click.prevent="OpenKlub">{{klub}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlub" :data="klubi" type="klubi" class="drop-down-btn" v-if="dKlub" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: nalet_jadralno.length > 0 }" class="label-time p-2" for="nalet_jadralno">{{$t('labels.naletJ')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="1" id="nalet_jadralno" v-model="nalet_jadralno" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: nalet_motorno.length > 0 }" class="label-time p-2" for="nalet_motorno">{{$t('labels.naletM')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="1" id="nalet_motorno" v-model="nalet_motorno" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: licenca.length > 0 }" class="label" for="licenca">{{$t('labels.licenca')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="licenca" v-model="licenca" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.instruktor')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="instruktor"  v-model="instruktor" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.instruktorJ')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="instruktor"  v-model="instruktorJ" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.instruktorUL')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="instruktor"  v-model="instruktorUL" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.vlecniR')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="vlecniR"  v-model="vlecniR" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.jadralniP')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="vlecniR"  v-model="jadralniPilot" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.motorniP')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="vlecniR"  v-model="motorniPilot" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="instruktor">{{$t('labels.ultraP')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="vlecniR"  v-model="ultraPilot" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{$t('labels.opomba')}}</label>
        <textarea class="input-comment border-0 rounded-4 p-2 fs-5" autocomplete="off" type="textarea" id="opomba" v-model="opomba" rows="6">
                    </textarea>
      </div>
    </div>
    <div class="m-2">
      <button @click.prevent="Add()" class="btn btn-primary rounded-pill btn-add col-12">{{$t('buttons.vnos')}}</button>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>